<div *ngIf="perdidas$ | async as perdidas">
    <div class="header border-background-2">
        <h3>Registro de clases perdidas <small>({{getSumaHoras(perdidas)}})</small></h3>
        <div class="sub-header"></div>
    </div>
    <div class="sub-header-button">
        <button mat-fab color="primary" (click)="dialogNew()">
            <mat-icon matTooltip="Agregar clase perdida">add</mat-icon>
        </button>
    </div>

    <clase-perdida-list 
        [errorMessage]="errorMessage$ | async"
        [loading]="loading$ | async"
        [perdidas]="perdidas"
        [materias]="materias$ | async"
        (delete)="delete($any($event))"
        >
    </clase-perdida-list>
</div>
